var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockerLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "locker_lock_icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-21.149,27.6H-24.5V21.582A13.619,13.619,0,0,0-38.114,7.963,13.619,13.619,0,0,0-51.732,21.582v6.01h-3.347a1.868,1.868,0,0,0-1.869,1.868h0V53.374a1.869,1.869,0,0,0,1.869,1.869h33.93a1.869,1.869,0,0,0,1.869-1.869h0V29.459A1.869,1.869,0,0,0-21.149,27.6ZM-36.225,42.152v2.513a1.889,1.889,0,0,1-1.822,1.955A1.889,1.889,0,0,1-40,44.8q0-.066,0-.132V42.152a3.237,3.237,0,0,1-.741-4.517,3.237,3.237,0,0,1,4.517-.741,3.237,3.237,0,0,1,.741,4.517A3.241,3.241,0,0,1-36.225,42.152ZM-47.727,27.6V21.582a9.613,9.613,0,0,1,9.4-9.822,9.612,9.612,0,0,1,9.821,9.4c0,.141,0,.282,0,.423v6.01Z",
    transform: "translate(67.948 -1.963)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerLock);
export default __webpack_public_path__ + "static/media/locker_lock.893fcacf68c8295f57379fefa49360da.svg";
export { ForwardRef as ReactComponent };